<template>
    <div>
        <v-overlay :value='InitLoading' opacity='0.8' class='text-center align-center justify-center align-content-center'>
            <v-progress-circular
                class='mb-2'
                color='primary'
                indeterminate
                size='50'
            ></v-progress-circular>
            <div>
                لطفا صبر کنید
            </div>
        </v-overlay>
    </div>
</template>

<script>
    export default {
        name: 'initialLoading',
        props: {
            InitLoading: Boolean
        }
        // data: () => ({
        //     overlay: false,
        // }),

        // watch: {
        //     InitLoading (val) {
        //         console.log(val);
        //         val && setTimeout(() => {
        //             this.InitLoading = false
        //         }, 10000)
        //     },
        // },
    };
</script>

<style scoped>

</style>